import { render } from "./NoAuthHeader.vue?vue&type=template&id=71f86e6d"
import script from "./NoAuthHeader.vue?vue&type=script&lang=js"
export * from "./NoAuthHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/collin/workspace/elands/elandsweb/main-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__